document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('select[id^="variant-select-"]').forEach(select => {

    const card = select.closest('product-form');
    const variantInput = card.querySelector('.product-variant-id');
    const freeInputs = card.querySelectorAll('.free-product-map');

    function updateVariant() {
      const selected = select.value;
      if (variantInput) {
        variantInput.value = selected;
      }

      freeInputs.forEach(input => {
        input.disabled = input.dataset.mainVariant != selected;
      });

    }

    updateVariant();

    select.addEventListener("change", updateVariant);

  });

});